'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

var _formatter = require('../common/formatter');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var CascadeMultiSelectField = (_temp = _class = function (_Field) {
  _inherits(CascadeMultiSelectField, _Field);

  function CascadeMultiSelectField() {
    _classCallCheck(this, CascadeMultiSelectField);

    return _possibleConstructorReturn(this, _Field.apply(this, arguments));
  }

  CascadeMultiSelectField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-cascade-multi-select'
    });
  };

  // onChange时触发，组件的值向全局store中赋值时的转换


  CascadeMultiSelectField.prototype.formatOut = function formatOut(value, data, extra) {
    return (0, _formatter.formatOut)(value, 'CascadeMultiSelect', data, extra);
  };

  CascadeMultiSelectField.prototype.getControlProps = function getControlProps() {
    var _this2 = this;

    var _props = this.props,
        hasClear = _props.hasClear,
        showSearch = _props.showSearch,
        notFoundContent = _props.notFoundContent,
        dataLevel = _props.dataLevel,
        _onChange = _props.onChange,
        _props$autoWidth = _props.autoWidth,
        autoWidth = _props$autoWidth === undefined ? false : _props$autoWidth;


    var listStyle = (0, _formFieldUtils.isIE)() ? { width: '150px' } : { minWidth: '150px', width: 'auto' };
    if (autoWidth) {
      var cascadeSize = this.getCascadeSize();
      listStyle = { width: 1 / cascadeSize * 100 + '%' };
    }

    var superProps = _Field.prototype.getControlProps.call(this);

    return _extends({}, superProps, {
      canOnlyCheckLeaf: dataLevel === 'LEAF',
      style: _extends({}, superProps.style, { width: '100%' }),
      hasClear: hasClear,
      showSearch: showSearch,
      notFoundContent: notFoundContent,
      autoWidth: autoWidth,
      listStyle: listStyle,
      dataSource: this.getOptions(true),
      onChange: function onChange(value, data, extra) {
        _onChange({ value: _this2.formatOut(value, data, extra) });
      }
    });
  };

  CascadeMultiSelectField.prototype.renderControl = function renderControl() {
    var controlProps = this.getControlProps();

    return _react2.default.createElement(_next.CascaderSelect, _extends({}, controlProps, { multiple: true }));
  };

  return CascadeMultiSelectField;
}(_vuFusionField2.default), _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  dataLevel: 'LEAF',
  notFoundContent: '无选项',
  autoWidth: false
}), _class.displayName = 'CascadeMultiSelect', _temp);
exports.default = CascadeMultiSelectField;
module.exports = exports['default'];